
namespace TabAurous.Master {

    @Serenity.Decorators.registerClass()
    export class CustomerCategoryDialog extends Serenity.EntityDialog<CustomerCategoryRow, any> {
        protected getFormKey() { return CustomerCategoryForm.formKey; }
        protected getIdProperty() { return CustomerCategoryRow.idProperty; }
        protected getLocalTextPrefix() { return CustomerCategoryRow.localTextPrefix; }
        protected getNameProperty() { return CustomerCategoryRow.nameProperty; }
        protected getService() { return CustomerCategoryService.baseUrl; }
        protected getDeletePermission() { return CustomerCategoryRow.deletePermission; }
        protected getInsertPermission() { return CustomerCategoryRow.insertPermission; }
        protected getUpdatePermission() { return CustomerCategoryRow.updatePermission; }

        protected form = new CustomerCategoryForm(this.idPrefix);

    }
}